export const fieldNames = {
    ARRIVAL_TIME: 'arrivalTime',
    BOOKABLE_PERIOD: 'bookablePeriod',
    DEPARTURE_TIME: 'departureTime',
    NAME: 'name',
    ACCOUNTING_CATEGORY_ID: 'accountingCategoryId',
    REBATE_ACCOUNTING_CATEGORY_ID: 'rebateAccountingCategoryId',
} as const;

export const DEFAULT_ARRIVAL_TIME_DAY = '08:00:00';
export const DEFAULT_ARRIVAL_TIME_HOUR = '00:00:00';
export const DEFAULT_ARRIVAL_TIME_NIGHT = '15:00:00';
export const DEFAULT_ARRIVAL_TIME_MONTH = '08:00:00';

export const DEFAULT_DEPARTURE_TIME_DAY = '20:00:00';
export const DEFAULT_DEPARTURE_TIME_HOUR = '00:00:00';
export const DEFAULT_DEPARTURE_TIME_NIGHT = '12:00:00';
export const DEFAULT_DEPARTURE_TIME_MONTH = '20:00:00';
